import api from '@pray/shared/utils/api';

import type { AnalyticsMetric, ConfigurableFunnelData } from './types/analytics';

export type GetConfigurableFunnelAnalyticsParams = {
  experimentId: string;
  instanceName?: string;
  experimentListNumber: number;
  startDate: string;
  endDate: string;
  funnelSteps: AnalyticsMetric[];
};

export type GetConfigurableFunnelAnalyticsResponse = {
  data: ConfigurableFunnelData;
};

/**
 * Fetches configurable funnel analytics data for an experiment.
 * Allows specifying custom funnel steps with dependency validation.
 */
export async function getConfigurableFunnelAnalytics({
  experimentId,
  instanceName,
  experimentListNumber,
  startDate,
  endDate,
  funnelSteps,
}: GetConfigurableFunnelAnalyticsParams): Promise<ConfigurableFunnelData> {
  if (!experimentId) throw new Error('Experiment ID is required');
  if (!funnelSteps.length) throw new Error('At least one funnel step is required');

  const url = `/web/studio/experiments/${experimentId}/analytics/funnel/configurable`;
  const params: Record<string, string | number> = {
    experiment_list_number: experimentListNumber,
    start_date: startDate,
    end_date: endDate,
    funnel_steps: funnelSteps.join(','),
  };

  if (instanceName) {
    params.instance_name = instanceName;
  }

  const response = await api.executeGetRequest<GetConfigurableFunnelAnalyticsResponse>(url, params);

  return response.data.data;
}
